import {
  lightTokens,
  darkTokens,
  type Fx,
  type Inks,
  type Lines,
  type Surface,
  type ToneMap,
  type TokenSet,
} from './tokens';
import { typography, type Typography } from './typography';
import {
  breakpoints,
  motion,
  radii,
  shadows,
  shadowsDark,
  spacing,
  widths,
  type Breakpoints,
  type Motion,
  type Radii,
  type Spacing,
  type Widths,
  type Shadows,
} from './spacing';

export type ThemeName = 'light' | 'dark';

export type Theme = {
  name: ThemeName;
  surface: Surface;
  ink: Inks;
  line: Lines;
  tone: ToneMap;
  fx: Fx;
  typography: Typography;
  spacing: Spacing;
  radii: Radii;
  shadows: Shadows;
  widths: Widths;
  breakpoints: Breakpoints;
  motion: Motion;
};

export const composeTheme = (name: ThemeName, tokens: TokenSet): Theme => ({
  name,
  ...tokens,
  typography,
  spacing,
  radii,
  shadows: name === 'dark' ? shadowsDark : shadows,
  widths,
  breakpoints,
  motion,
});

export const themes: Record<ThemeName, Theme> = {
  light: composeTheme('light', lightTokens),
  dark: composeTheme('dark', darkTokens),
};

export type { Surface, Inks, Lines, Tone, ToneMap, ToneName, Fx } from './tokens';
export type { Typography } from './typography';
export type { Spacing, Radii, Shadows, Widths, Breakpoints, Motion } from './spacing';
